import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import AuroraBackground from "@/components/AuroraBackground";

const Impresszum = () => {
  return (
    <main className="relative min-h-screen overflow-x-hidden">
      <AuroraBackground />
      
      <div className="relative z-10 container max-w-4xl mx-auto px-4 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Vissza a főoldalra
          </Link>
          
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Impresszum
          </h1>
          
          <div className="glass-card p-8 md:p-12">
            <p className="text-xl text-muted-foreground">
              Hamarosan...
            </p>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default Impresszum;
